/*Package importing*/
import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import $ from 'jquery';

/*Components*/
import SelectBox from '../../components/formComponents/selectBox';
import APILoader from '../../components/other/api-loader';
import NoDataFound from '../../components/other/nothing';
import Toast from '../../components/toast/toast';
import SectionHeadingStyle from '../../components/elementsPreview/sectionHeadingStyle';
import Input from '../../components/formComponents/input';
import Textarea from '../../components/formComponents/textarea';
import ImageUploader from '../../services/upload/imageUploader';
import HeadingSelectionModal from '../../components/modals/chooseHeadingStyle';
import BannerStyle from '../../components/modals/banner';
import Banner from '../../components/elementsPreview/bannerPreview';
import ListSelectionModal from '../../components/modals/listSelection';
import List from '../../components/elementsPreview/listPreview';
import VideoPlayer from '../../components/common/video';
/*Assets*/

/*Services*/
import devconfig from '../../config/config.js';
import APIPost from '../../services/apiCall/post';
import APIGet from '../../services/apiCall/get';

const image2 = "https://i.pinimg.com/originals/15/ac/b0/15acb0ec65ce3962d676a1ee05c448d0.png";
const image = "https://i.pinimg.com/originals/0b/46/ce/0b46ceb1581581d7ca5069c7120d269b.jpg" ;
const tempLink = "https://www.google.com";
const header = {content: "Store Name", font_color: "#202020", type: 20, bg_color: "#202020"}
const data = {collections: {content: "Collections", font_color: "#202020", type: 20, bg_color: "#202020"},
    newArrivals: {content: "New Arrivals", font_color: "#202020", type: 20, bg_color: "#202020"},
    deals: {content: "Deals of the Day", font_color: "#202020", type: 20, bg_color: "#202020"},
    featured: {content: "Featured", font_color: "#202020", type: 20, bg_color: "#202020"},
    last: {content: "Last Chance to buy", font_color: "#202020", type: 20, bg_color: "#202020"},
    budgetBuys: {content: "Budget Buys", font_color: "#202020", type: 20, bg_color: "#202020"},
    moreBrands: {content: "More Brands", font_color: "#202020", type: 20, bg_color: "#202020"},
    products: {content: "Products", font_color: "#202020", type: 20, bg_color: "#202020"},
    about: {content: "About the Store", font_color: "#202020", type: 20, bg_color: "#202020"}}

class Store extends Component {
  constructor(props){
    super(props);
    this.state = {
      apiLoading: false,
      data: {
        header: header,
        banner:{},
        layout: {
                collections: {
                    header: data.collections,
                    data:{},
                },
                newArrivals: {
                    header: data.newArrivals,
                    banner:{},
                },
                offers:{
                    banner:{},
                },
                deals: {
                    header: data.deals,
                    banner:{},
                },
                featured: {
                    header: data.featured,
                    banner:{},
                },
                last: {
                    header: data.last,
                    data:{},
                },
                budgetBuys: {
                    header: data.budgetBuys,
                    data:{},
                },
                moreBrands: {
                    header: data.moreBrands,
                    data:{},
                },
                productList: {
                    header: data.products,
                    data:{},
                },
                description : {
                    header: data.about,
                    data:{
                        about: "",
                        address: "",
                        socialmedia_links: {facebook: "", instagram: "", twitter: "", youtube: "", pinterest: ""},
                        other_links: {return:"", refund: "", exchange: ""},
                        payment_methods: ""
                    },
                }
            }
        },
      about: "",
      address: "",
      socialMedia: {facebook: "", instagram: "", twitter: "", youtube: "", pinterest: ""},
      links: {return:"", refund: "", exchange: ""},
      mapLink: "",
      paymentMethods: "",  
      error: "",
      toast: null,
      toastType: ""
    }
  }

  componentDidMount() {
    //   console.log(this.state.layout.moreBrands.header)
     this.getData();
     this.getCatList(); 
     this.getProfileData();
  }
  async getCatList() {
    let url = devconfig.localVendor + "category/selected-list";
    let response = await APIGet(url);
    if (response && response.status == "ok") {
        let list = [];
        if (response.subcategories && response.subcategories.length) list = response.subcategories;
        // this.setState({ subcategoryList: list });
    }
}

getProfileData(){
    this.setState({apiLoading: true});
    var url = devconfig.vendor+ 'auth/profile';
    APIGet(url).then(function(response){
        let options =[];
        for (let index = 0; index < response.data.category_data.length; index++) {
            const category = response.data.category_data[index];
            for (let catIndex = 0; catIndex < category.category.length; catIndex++) {
                const subCat = category.category[catIndex];
                for (let subIndex = 0; subIndex < subCat.sub_category.length; subIndex++) {
                    const product = subCat.sub_category[subIndex];
                    options.push({ value: product.id, label: product.sub_category})
                }
            }
            
        }
        console.log('product', options)
        this.setState({ subcategoryList : options})
    }.bind(this))
  }

  async getData(){
    let temp;
    let url = devconfig.vendor+ 'layout/get-layout';
    APIGet(url).then( async function(response){
      if(response.status == "ok"){
        if(response.data.layout){
        //    await this.setState({data: response.data.layout});
            if(response.data.layout.layout && response.data.layout.layout.description && response.data.layout.layout.description.data){
                this.setState({about: response.data.layout.layout.description.data.about, address: response.data.layout.layout.description.data.address, socialMedia: response.data.layout.layout.description.data.socialmedia_links, links: response.data.layout.layout.description.data.other_links, paymentMethods: response.data.layout.layout.description.data.payment_methods, mapLink: response.data.layout.layout.description.data.map_link})
            }
            temp = response.data.layout;
            if(temp.layout.productList){
                console.log(temp)
            }else{
                temp.layout = {
                    ...temp.layout,
                    productList: {
                        header:  {content: "Products", font_color: "#202020", type: 20, bg_color: "#202020"},
                        data:{},
                    },
                }
            }
            this.setState({ data: temp})
        }
        else if(response.data.is_favoutlayout){
        //    await  this.setState({data: response.data.is_favoutlayout});
            if(response.data.is_favoutlayout.layout && response.data.is_favoutlayout.layout.description && response.data.is_favoutlayout.layout.description.data){
                this.setState({about: response.data.is_favoutlayout.layout.description.data.about, address: response.data.is_favoutlayout.layout.description.data.address, socialMedia: response.data.is_favoutlayout.layout.description.data.socialmedia_links, links: response.data.is_favoutlayout.layout.description.data.other_links, paymentMethods: response.data.is_favoutlayout.layout.description.data.payment_methods, mapLink: response.data.is_favoutlayout.layout.description.data.map_link})
            }
            temp = response.data.is_favoutlayout;
            if(temp.layout.productList){
                console.log(temp)
            }else{
                temp.layout = {
                    ...temp.layout,
                    productList: {
                        header:  {content: "Products", font_color: "#202020", type: 20, bg_color: "#202020"},
                        data:{},
                    },
                }
            }
            this.setState({ data: temp})
        }
      }
      else{
        this.setState({error: response.message});
      }
    }.bind(this))
    
}
setLayout(temp){
    console.log('temo--->',temp)
}
  setHeadingStyle(data){
      console.log(data);
      let temp =this.state.data;
      console.log(temp)
      if(data.header.main){
          console.log('temp', temp.header.content);
        temp.header.type = data.type;
        temp.header.font_color = data.font_color;
        temp.header.bg_color = data.bg_color;
       temp.header.content = data.new_name;
      }
      else{
          console.log(temp.layout[data.header.name].header.content)
        temp.layout[data.header.name].header.type = data.type;
        temp.layout[data.header.name].header.font_color = data.font_color;
        temp.layout[data.header.name].header.bg_color = data.bg_color;
        temp.layout[data.header.name].header.content = data.new_name;
      }
      this.setState({data: temp})
  }

  async setBanner(file, style){
      let temp = this.state.data;
      let item = this.state.updateBanner;
      if(item.main){
          temp.banner = {banner_type: style.id, data: []}
          file.forEach(element => {
              if(element.file){
                  let temp1 = {content: element.fileURL, link: element.website};
                  temp.banner.data.push(temp1);
              }
          });
      }
      else{
          temp.layout[item.name].banner = {banner_type: style.id, data: []}
          file.forEach(element => {
              if(element.file){
                  let temp1 = {content: element.fileURL, link: element.website};
                  temp.layout[item.name].banner.data.push(temp1);
              }
          });
      }
      
      await this.setState({data: temp});
      await console.log(this.state.data, temp);
  }

  removeBanner(item){
      let temp = this.state.data;
      if(item.main){
        temp.banner = {};
      }
      else{
        temp.layout[item.name].banner ={};
      }

      this.setState({data: temp});
  }

  removeList(item){
    let temp = this.state.data;
    temp.layout[item].data ={};
    this.setState({data: temp});
  }

  async editList(data, item){
      let temp = this.state.data;
      temp.layout[item].data = data;
      this.setState({data: temp});
      await console.log(this.state.data)
  }

  setLinks(value, item){
      let temp = this.state.links;
      temp[item] = value;
      this.setState({links: temp});
  }

  updateSocial(value, item){
    let temp = this.state.socialMedia;
    temp[item] = value;
    this.setState({socialMedia: temp});
  }

  async setStoreInfo(){
      let item = this.state.data;
      let vendorName = JSON.parse(localStorage.getItem('vendor_data'));
      item.header.content = vendorName.name;
      item.layout.description.data = {about: this.state.about, address: this.state.address, socialmedia_links: this.state.socialMedia, other_links: this.state.links, payment_methods: this.state.paymentMethods, map_link: this.state.mapLink};
      let url = devconfig.vendor+ 'layout/update-layout';
      let data = JSON.stringify({
          "layout": item,
          "map_link": this.state.mapLink
      });
      APIPost(url, data).then(function(response){
        if(response.status == "ok"){
          console.log(data)
        }
        else{
          this.setState({error: response.message});
        }
      }.bind(this))
  }

  render() {
    let vendorName = JSON.parse(localStorage.getItem('vendor_data'));
    let storeName = {content: vendorName.name, font_color: '#202020', type: 20, bg_color: '#202020'}
    // console.log(vendorName)
    return (
      <React.Fragment>
        <div>
          <div className="e-main-content e-vendor-table e-vendor-store">     
          <div className="e-page-head container p-0 pr-lg-3">
                <div className="row">
                    <div className="col-lg-4">
                        <h2 className="">My Store Layout</h2>
                    </div>
                    <div className="col-lg-6 pr-lg-5 pr-xl-3 py-3 py-lg-0">
                    {
                      !this.state.error?
                      <button className="e-s-btn e-new-ofer mt-n3" onClick={()=> this.setStoreInfo()}>Update Page</button>
                      :
                      <button className="e-s-btn e-new-ofer mt-n3  e-inactive" disabled={true}>Update Page</button>
                    }
                    </div>
                </div>
            </div> 

            <div className="row pb-4">
                <div className="col-lg-12">
                    <div className="e-vendor-category-list">
                        <div className="e-column border-0">
                            <div className="row">
                                <div className="col-lg-12 mt-2 ">
                                    <div className="container px-0 position-relative">
                                        {/* <span className="e-edit" data-toggle="modal" data-target="#headerModal" onClick={()=>this.setState({editHeader: {main: true}})}></span> */}
                                        <SectionHeadingStyle data={storeName}/>
                                    </div>
                                </div>
                                <div className="col-lg-12 pt-3">
                                    {
                                        this.state.data.banner.data?
                                        <div className="position-relative">
                                            <span className="e-close-icon mt-2 position-absolute" style={{top: 0, right: 0, zIndex: 1}} onClick={()=>this.removeBanner({main: true})}></span>
                                                {
                                                     this.state.data.banner.data[0].content.indexOf(".mp4") > -1 ?
                                                     <VideoPlayer url={this.state.data.banner.data[0].content} />
                                                     :
                                                    <Banner banner={this.state.data.banner}/>
                                                }   
                                           
                                        </div>
                                        :
                                        <div className="container px-0 e-upload-border py-5" data-toggle="modal" data-target="#bannerStyleModal" onClick={()=>this.setState({updateBanner: {main: true}})} style={{cursor: "pointer"}}>
                                            <div className="e-ad-full-placeholder">
                                                Add Banner
                                            </div>
                                        </div>
                                    }
                                </div>
                            </div>
                        </div>
                        <div className="e-column border-0 mt-3">
                            <div className="row">
                                <div className="col-lg-12 pt-2">
                                    <div className="container px-0 position-relative">
                                        <span className="e-edit" data-toggle="modal" data-target="#headerModal" onClick={()=>this.setState({editHeader: {main: false, name: "collections"}})}></span>
                                        <SectionHeadingStyle data={this.state.data.layout.collections.header}/>
                                    </div>
                                </div>
                                <div className="col-lg-12 pt-3">
                                    {
                                        this.state.data.layout.collections.data.content?
                                        <div className="container px-0 mt-3 position-relative">
                                            <span className="e-close-icon position-absolute" style={{top: 0, right: 0, zIndex: 1}} onClick={()=>this.removeList("collections")}></span>
                                            <List info={this.state.data.layout.collections} />
                                        </div>
                                        : 
                                        <div className="e-section-head-placeholder e-upload-border" data-toggle="modal" data-target="#listModal" onClick={()=>this.setState({editList: "collections"})}>
                                        + Add Category List
                                        </div>
                                    }
                                </div>
                            </div>
                        </div> 
                        <div className="e-column border-0 mt-3">
                            <div className="row">
                                <div className="col-lg-12 pt-2">
                                    <div className="container px-0 position-relative">
                                        <span className="e-edit" data-toggle="modal" data-target="#headerModal" onClick={()=>this.setState({editHeader: {main: false, name: "newArrivals"}})}></span>
                                        <SectionHeadingStyle data={this.state.data.layout.newArrivals.header}/>
                                    </div>
                                </div>
                                <div className="col-lg-12 pt-3">
                                    {
                                        this.state.data.layout.newArrivals.banner.data?
                                        <div className="position-relative">
                                            <span className="e-close-icon mt-2 position-absolute" style={{top: 0, right: 0, zIndex: 1}} onClick={()=>this.removeBanner({main: false, name:"newArrivals"})}></span>
                                            <Banner banner={this.state.data.layout.newArrivals.banner}/>
                                        </div>
                                        :
                                        <div className="container e-upload-border px-0 py-5" data-toggle="modal" data-target="#bannerStyleModal" onClick={()=>this.setState({updateBanner: {main: false, name: "newArrivals"}})} style={{cursor: "pointer"}}>
                                            <div className="e-ad-full-placeholder">
                                                Add Banner
                                            </div>
                                        </div>
                                    }
                                </div>
                                <div className="col-lg-12 pt-3">
                                    {
                                        this.state.data.layout.offers.banner.data?
                                        <div className="position-relative">
                                            <span className="e-close-icon mt-2 position-absolute" style={{top: 0, right: 0, zIndex: 1}} onClick={()=>this.removeBanner({main: false, name: "offers"})}></span>
                                            <Banner banner={this.state.data.layout.offers.banner} />
                                        </div>
                                        
                                        :
                                        <div className="container e-upload-border px-0 py-5" data-toggle="modal" data-target="#bannerStyleModal" onClick={()=>this.setState({updateBanner: {main: false, name: "offers"}})} style={{cursor: "pointer"}}>
                                            <div className="e-ad-full-placeholder">
                                                Add Banner
                                            </div>
                                        </div>

                                    }
                                </div>
                            </div>
                        </div> 
                        <div className="e-column border-0 mt-3">
                            <div className="row">
                                <div className="col-lg-12 pt-2">
                                    <div className="container px-0 position-relative">
                                        <span className="e-edit" data-toggle="modal" data-target="#headerModal" onClick={()=>this.setState({editHeader: {main: false, name: "featured"}})}></span>
                                        <SectionHeadingStyle data={this.state.data.layout.featured.header}/>
                                    </div>
                                </div>
                                <div className="col-lg-12 pt-3">
                                    {
                                        this.state.data.layout.featured.banner.data?
                                        <div className="position-relative">
                                            <span className="e-close-icon mt-2 position-absolute" style={{top: 0, right: 0, zIndex: 1}} onClick={()=>this.removeBanner({main: false, name: "featured"})}></span>
                                            <Banner banner={this.state.data.layout.featured.banner} />
                                        </div>
                                        
                                        :
                                        <div className="container e-upload-border px-0 py-5" data-toggle="modal" data-target="#bannerStyleModal" onClick={()=>this.setState({updateBanner: {main: false, name: "featured"}})} style={{cursor: "pointer"}}>
                                            <div className="e-ad-full-placeholder">
                                                Add Banner
                                            </div>
                                        </div>
                                    }
                                    
                                </div>
                            </div>
                        </div> 
                        <div className="e-column border-0 mt-3">
                            <div className="row">
                                <div className="col-lg-12 pt-2">
                                    <div className="container px-0 position-relative">
                                        <span className="e-edit" data-toggle="modal" data-target="#headerModal" onClick={()=>this.setState({editHeader: {main: false, name: "last"}})}></span>
                                        <SectionHeadingStyle data={this.state.data.layout.last.header}/>
                                    </div>
                                </div>
                                <div className="col-lg-12 pt-3">
                                    {
                                        this.state.data.layout.last.data.content?
                                        <div className="container px-0 mt-3 position-relative">
                                            <span className="e-close-icon position-absolute" style={{top: 0, right: 0, zIndex: 1}} onClick={()=>this.removeList("last")}></span>
                                            <List info={this.state.data.layout.last} />
                                        </div>
                                        : 
                                        <div className="e-section-head-placeholder e-upload-border" data-toggle="modal" data-target="#listModal" onClick={()=>this.setState({editList: "last"})}>
                                        + Add Category List
                                        </div>
                                    }
                                </div>
                            </div>
                        </div>
                        <div className="e-column border-0 mt-3">
                            <div className="row">
                                <div className="col-lg-12 pt-2">
                                    <div className="container px-0 position-relative">
                                        <span className="e-edit" data-toggle="modal" data-target="#headerModal" onClick={()=>this.setState({editHeader: {main: false, name: "deals"}})}></span>
                                        <SectionHeadingStyle data={this.state.data.layout.deals.header}/>
                                    </div>
                                </div>
                                <div className="col-lg-12 pt-3">
                                    {
                                        this.state.data.layout.deals.banner.data?
                                        <div className="position-relative">
                                            <span className="e-close-icon mt-2 position-absolute" style={{top: 0, right: 0, zIndex: 1}} onClick={()=>this.removeBanner({main: false, name: "deals"})}></span>
                                            <Banner banner={this.state.data.layout.deals.banner} />
                                        </div>
                                        :
                                        <div className="container e-upload-border px-0 py-5" data-toggle="modal" data-target="#bannerStyleModal" onClick={()=>this.setState({updateBanner: {main: false, name: "deals"}})} style={{cursor: "pointer"}}>
                                        <div className="e-ad-full-placeholder">
                                            Add Banner
                                        </div>
                                    </div>
                                    }
                                </div>
                            </div>
                        </div>
                        <div className="e-column border-0 mt-3">
                            <div className="row">
                                <div className="col-lg-12 pt-2">
                                    <div className="container px-0 position-relative">
                                        <span className="e-edit" data-toggle="modal" data-target="#headerModal" onClick={()=>this.setState({editHeader: {main: false, name: "budgetBuys"}})}></span>
                                        <SectionHeadingStyle data={this.state.data.layout.budgetBuys.header}/>
                                    </div>
                                </div>
                                <div className="col-lg-12 pt-3">
                                    {
                                        this.state.data.layout.budgetBuys.data.content?
                                        <div className="container px-0 mt-3 position-relative">
                                            <span className="e-close-icon position-absolute" style={{top: 0, right: 0, zIndex: 1}} onClick={()=>this.removeList("budgetBuys")}></span>
                                            <List info={this.state.data.layout.budgetBuys} />
                                        </div>
                                        : 
                                        <div className="e-section-head-placeholder e-upload-border" data-toggle="modal" data-target="#listModal" onClick={()=>this.setState({editList: "budgetBuys"})}>
                                        + Add Category List
                                        </div>
                                    }
                                </div>
                            </div>
                        </div>
                        <div className="e-column border-0 mt-3">
                            <div className="row">
                                <div className="col-lg-12 pt-2">
                                    <div className="container px-0 position-relative">
                                        <span className="e-edit" data-toggle="modal" data-target="#headerModal" onClick={()=>this.setState({editHeader: {main: false, name: "moreBrands"}})}></span>
                                        <SectionHeadingStyle data={this.state.data.layout.moreBrands.header}/>
                                        
                                    </div>
                                </div>
                                <div className="col-lg-12 pt-3">
                                    {
                                        this.state.data.layout.moreBrands.data.content?
                                        <div className="container px-0 mt-3 position-relative">
                                            <span className="e-close-icon position-absolute" style={{top: 0, right: 0, zIndex: 1}} onClick={()=>this.removeList("moreBrands")}></span>
                                            <List info={this.state.data.layout.moreBrands} />
                                        </div>
                                        : 
                                        <div className="e-section-head-placeholder e-upload-border" data-toggle="modal" data-target="#listModal" onClick={()=>this.setState({editList: "moreBrands"})}>
                                        + Add Category List
                                        </div>
                                    }
                                </div>
                            </div>
                        </div>
                         <div className="e-column border-0 mt-3">
                            <div className="row">
                                <div className="col-lg-12 pt-2">
                                    <div className="container px-0 position-relative">
                                        <span className="e-edit" data-toggle="modal" data-target="#headerModal" onClick={()=>this.setState({editHeader: {main: false, name: "productList"}})}></span>
                                     
                                        <SectionHeadingStyle data={this.state.data.layout.productList.header}/>
                                    </div>
                                </div>
                                <div className="col-lg-12 pt-3">
                                    {
                                        this.state.data.layout.productList.data.content?
                                        <div className="container px-0 mt-3 position-relative">
                                            <span className="e-close-icon position-absolute" style={{top: 0, right: 0, zIndex: 1}} onClick={()=>this.removeList("productList")}></span>
                                            <List info={this.state.data.layout.productList} />
                                        </div>
                                        : 
                                        <div className="e-section-head-placeholder e-upload-border" data-toggle="modal" data-target="#listModal" onClick={()=>this.setState({editList: "productList"})}>
                                        + Add Category List
                                        </div>
                                    }
                              </div>
                            </div>
                        </div> 
                        <div className="e-column border-0 mt-3">
                            <div className="row pt-4">
                                <div className="col-lg-12 pt-2 pb-3">
                                    <div className="container px-0 position-relative">
                                        <span className="e-edit" data-toggle="modal" data-target="#headerModal" onClick={()=>this.setState({editHeader: {main: false, name: "description"}})}></span>
                                        <SectionHeadingStyle data={this.state.data.layout.description.header}/>
                                    </div>
                                </div>
                                <div className="col-lg-6">
                                    <label>About</label>
                                    <Textarea id="about " defaultValue={this.state.about} type="text" className="e-add-career" valueChange={(val)=>{this.setState({about: val})}} placeholder="(Max 100 characters)"/>
                                </div>
                                <div className="col-lg-6">
                                    <label>Address</label>
                                    <Textarea id="address" defaultValue={this.state.address} type="text" className="e-add-career" valueChange={(val)=>{this.setState({address: val})}} placeholder="(Max 100 characters)"/>
                                </div>
                                <div className="col-lg-6">
                                    <label>Social Media Links</label>
                                    <Input id="social-media-fb" defaultValue={this.state.socialMedia.facebook} type="text" className="e-add-career" valueChange={(val)=>{this.updateSocial(val, "facebook")}} placeholder="Facebook link"/>
                                    <Input id="social-media-ig" defaultValue={this.state.socialMedia.instagram} type="text" className="e-add-career" valueChange={(val)=>{this.updateSocial(val, "instagram")}} placeholder="Instagram link"/>
                                    <Input id="social-media-tw" defaultValue={this.state.socialMedia.twitter} type="text" className="e-add-career" valueChange={(val)=>{this.updateSocial(val, "twitter")}} placeholder="Twitter link"/>
                                    <Input id="social-media-pi" defaultValue={this.state.socialMedia.pinterest} type="text" className="e-add-career" valueChange={(val)=>{this.updateSocial(val, "pinterest")}} placeholder="Pintrest link"/>
                                    <Input id="social-media-yt" defaultValue={this.state.socialMedia.youtube} type="text" className="e-add-career" valueChange={(val)=>{this.updateSocial(val, "youtube")}} placeholder="Youtube link"/>
                                </div>
                                <div className="col-lg-6">
                                    <label>Other Links</label>
                                    <Input id="return-policy" defaultValue={this.state.links.return} type="text" className="e-add-career" valueChange={(val)=>{this.setLinks(val, "return")}} placeholder="Return Policy"/>
                                    <Input id="refund-policy" defaultValue={this.state.links.refund} type="text" className="e-add-career" valueChange={(val)=>{this.setLinks(val, "refund")}} placeholder="Refund Policy"/>
                                    <Input id="exchange-policy" defaultValue={this.state.links.exchange} type="text" className="e-add-career" valueChange={(val)=>{this.setLinks(val, "exchange")}} placeholder="Exchange Policy"/>
                                    <label className="mt-4">Location </label>
                                    <Input id="map-link" defaultValue={this.state.mapLink} type="text" className="e-add-career" valueChange={(val)=>this.setState({mapLink: val})} placeholder="https://g.page/example?share"/>
                                </div>
                                <div className="col-lg-6 pt-3">
                                    <label>Accepted Payment methods</label>
                                    <Input id="payment-methods" defaultValue={this.state.paymentMethods} type="text" className="e-add-career" valueChange={(val)=>{this.setState({paymentMethods: val})}} placeholder="Cash, Card & UPI"/>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div> 
            <div className="row pt-2 pb-5">
                <div className="col-lg-12 pb-3">
                    {
                      !this.state.error?
                      <button className="e-s-btn e-new-ofer float-left" onClick={()=> this.setStoreInfo()}>Update Page</button>
                      :
                      <button className="e-s-btn e-new-ofer float-left  e-inactive" disabled={true}>Update Page</button>
                    }
                </div>
            </div>      
          </div>
        </div>
        
        <ListSelectionModal success={(data, list)=> this.editList(data, list)} list={this.state.editList} options={this.state.subcategoryList}/>
        <BannerStyle saveBanner={(file, style)=>this.setBanner(file, style)}/>
        <HeadingSelectionModal success={(data)=> this.setHeadingStyle(data)} updateName={(temp)=> console.log(temp)} headerContent={this.state.Heading} heading={this.state.editHeader} textEditable={true}/>
      </React.Fragment>

    );
  }
}

export default Store;
